import PersonioIcon from '~src/images/logos/personio_integration.png';
import HRlabIcon from '~src/images/logos/hrlab_integration.png';

import { IntegrationItemViewI } from './IntegrationsList';
import { IntegrationTypes } from './types';

export const integrationsConfig: IntegrationItemViewI[] = [
  {
    name: IntegrationTypes.HrLab,
    props: {
      title: 'x.company.import.form_hrlab.title',
      description: 'x.company.import.form_hrlab.description',
      integrationHelp: 'x.company.import.hrlab_help',
      icon: HRlabIcon,
      configForm: {
        name: 'import_hrlab_settings',
        fields: [
          {
            name: 'api_key',
            labelKey: 'x.company.import.config.hrlab_api_key_label',
            tooltipTxt: 'x.company.import.config.hrlab_api_key_description',
          },
        ],
      },
    },
  },
  {
    name: IntegrationTypes.Personio,
    props: {
      title: 'x.company.import.form_personio.title',
      description: 'x.company.import.form_personio.description',
      integrationHelp: 'x.company.import.personio_help',
      icon: PersonioIcon,
      configForm: {
        name: 'import_personio_settings',
        fields: [
          {
            name: 'client_id',
            labelKey: 'x.company.import.config.client_id_label',
            tooltipTxt: 'x.company.import.config.client_id_description',
          },
          {
            name: 'client_secret',
            labelKey: 'x.company.import.config.client_secret_label',
            tooltipTxt: 'x.company.import.config.client_secret_description',
          },
        ],
      },
    },
  },
  {
    name: IntegrationTypes.Csv,
    props: {
      title: 'x.company.import.from_csv.title',
      description: 'x.company.import.from_csv.description',
      integrationHelp: 'x.company.import.csv_help',
      svgIcon: 'iconCsv',
      configForm: {
        name: 'import_csv_settings',
        fields: [
          {
            name: 'delimiter',
            labelKey: 'x.company.import.config.delimiter_input_label',
            tooltipTxt: 'x.company.import.config.delimiter_description',
          },
        ],
      },
    },
  },
];
